import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-chevron-down',
  standalone: true,
  templateUrl: './icon-chevron-down.component.html',
  styleUrl: './icon-chevron-down.component.css'
})
export class IconChevronDownComponent { }
